import React, { useContext, useRef, useState } from 'react';

// import API from '../../services/api';
import AuthContext from '../../components/shared/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import LangSwitcher from '../../components/langSwitcher';


function ResetPassword(props) {

    const [t, i18n] = useTranslation();

    const userName = useRef("");
    const code = useRef("");
    const password = useRef("");
    const confirmation_password = useRef("");

    const [code_verification, setCode] = useState(null);

    const [showPass, setShowPass] = useState(false);

    const showPassword = (event) => {
        event.preventDefault();
        setShowPass(!showPass);
    }

    const { checkEmail, checkCode, setNewPassword }= useContext(AuthContext);

    const navigate = useNavigate();

    const steps = [t('Your Email'), t('Verification Code'), t('New Password')];

    const [activeStep, setActiveStep] = React.useState(0);


    
    
    const handleNext = () => {
        
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    

    
    const handleReset = () => {
        setActiveStep(0);
    };


    const goToLogin = () => {
        navigate('/login');
    }

    const _checkEmail = async (event) => {
        event.preventDefault();
        
        if(userName.current.value.trim().length > 0){
            let payload = {

                email: userName.current.value
            }
    
            try {
                let response = await checkEmail(payload);
    
                console.log(response);
    
                if(response.data.success == true){
                    Swal.fire({
                        icon: 'success',
                        title: 'Email verification',
                        text: 'Check your email to get the code',
                    });
                    userName.current.value = "";
                    handleNext();
                }else{
                    Swal.fire({
                        icon: 'warning',
                        title: 'Email verification',
                        text: 'Your email not valid',
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: 'Something went wrong!, try again',
                });
            }
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Field email should be not empty'),
            });
        }
        
    }

    const _checkCode = async (event) => {
        event.preventDefault();
        
        if(code.current.value.trim().length > 0){
            let payload = {

                code: code.current.value
            }
    
            try {
                let response = await checkCode(payload);
    
                console.log(response);
    
                if(response.data.success == true){
                    setCode(code.current.value);
                    code.current.value = "";
                    handleNext();
                }else{
                    Swal.fire({
                        icon: 'warning',
                        title:  t('Code verification'),
                        text: t(response.data.message.code),
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
            }
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Field code should be not empty'),
            });
        }
    }

    const _setNewPassword = async (event) => {
        event.preventDefault();
        
        if(password.current.value.trim().length > 0 && confirmation_password.current.value.trim().length > 0){
            if(password.current.value !== confirmation_password.current.value){
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('password and confirmation password are not same'),
                });
                return;
            }

            if(password.current.value.length < 6){
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('The password field must be at least 6 characters.'),
                });
                return;
            }

            let payload = {
                "code": code_verification,
                "password": password.current.value,
                "password_confirmation": confirmation_password.current.value
            }
    
            try {
                let response = await setNewPassword(payload);
    
                console.log(response);
    
                if(response.data.success == true){
                    handleNext();
                }else{
                    Swal.fire({
                        icon: 'warning',
                        title:  t('Password confirmation'),
                        text: t(response.data.message.code)
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
            }
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Field passsword and confirmation password should be not empty') ,
            });
        }
    }

    
    

    return (
        <div >
            {/* <!-- PAGE --> */}
            <div className="page" style={{ backgroundColor: "#f8fafc"}}>
                <div className="">



                    <div className="container">
                        <div className="wrap-login100 p-6">
                            <form className="login100-form validate-form" onSubmit={()=>{}}>
                                <span className="login100-form-title pb-5">
                                    {t('Reset Password')}
                                </span>
                                <div className="panel panel-primary">
                                    
                                    <div className="panel-body tabs-menu-body p-0 pt-5">
                                        <div className="tab-content">
                                            <Box sx={{ width: '100%' }}>
                                                <Stepper activeStep={activeStep}>
                                                    {steps.map((label, index) => {
                                                    const stepProps = {};
                                                    const labelProps = {};
                                                   
                                                    return (
                                                        <Step key={label} {...stepProps}>
                                                        <StepLabel {...labelProps}>{label}</StepLabel>
                                                        </Step>
                                                    );
                                                    })}
                                                </Stepper>
                                                {activeStep === steps.length ? (
                                                    <Box sx={{ paddingTop: 5, paddingBottom: 2 }}>
                                                        <Typography sx={{ mt: 2, mb: 1, textAlign: "center" }}>
                                                            {t('All steps completed - Sign in Now')}
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', justifyContent: "center" }}>
                                                            <Button sx={{ mt: 3 }} onClick={goToLogin}>{t('Login')}</Button>
                                                        </Box>
                                                    </Box>
                                                ) : (
                                                    <React.Fragment >
                                                    {activeStep ==  0 ?(
                                                        <Box sx={{ paddingTop: 5, paddingBottom: 2 }}>
                                                            <div className="tab-pane active" id="tab5">
                                                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                                                    <span  className="input-group-text bg-white text-muted">
                                                                        <i className="zmdi zmdi-email text-muted" aria-hidden="true"></i>
                                                                    </span>
                                                                    <input className="input100 border-start-0 form-control ms-0" autoComplete={false} type="email" ref={userName} placeholder="Email" />
                                                                </div>
                                                                <Box sx={{ display: 'flex', justifyContent: "center" }}>
                                                                    <Button sx={{ mt: 3 }} onClick={_checkEmail}>
                                                                        {activeStep === steps.length - 1 ? t('Finish')  : t('Next') }
                                                                    </Button>
                                                                </Box>
                                                                
                                                            </div>
                                                        </Box>
                                                    ): activeStep == 1 ? (
                                                        <Box sx={{ paddingTop: 5, paddingBottom: 2 }}>
                                                            <div className="tab-pane active" id="tab5">
                                                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                                                    <span  className="input-group-text bg-white text-muted">
                                                                        <i className="zmdi zmdi-dialpad text-muted" aria-hidden="true"></i>
                                                                    </span>
                                                                    <input className="input100 border-start-0 form-control ms-0" autoComplete={false} type="text" ref={code} placeholder="code" />
                                                                </div>
                                                                <Box sx={{ display: 'flex', justifyContent: "center" }}>
                                                                    <Button sx={{ mt: 3 }} onClick={_checkCode}>
                                                                        {activeStep === steps.length - 1 ? t('Finish')  : t('Next')}
                                                                    </Button>
                                                                </Box>
                                                                
                                                            </div>
                                                        </Box>
                                                    ): (
                                                        <Box sx={{ paddingTop: 5, paddingBottom: 2 }}>
                                                            <div className="tab-pane active" id="tab5">
                                                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                                                    <span  className="input-group-text bg-white text-muted">
                                                                        <i className="zmdi zmdi-lock-outline" aria-hidden="true"></i>
                                                                    </span>
                                                                    <input className="input100 border-start-0 form-control ms-0" autoComplete={false} defaultValue={""} type={!showPass ? "password" : "text"} ref={password} placeholder={t("new password")} />
                                                                    <button onClick={showPassword} className="input-group-text bg-white text-muted">
                                                                        {showPass ? <i className="zmdi zmdi-eye-off" aria-hidden="true"></i> : <i className="zmdi zmdi-eye" aria-hidden="true"></i>}
                                                                    </button>
                                                                </div>
                                                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                                                    <span  className="input-group-text bg-white text-muted">
                                                                        <i className="zmdi zmdi-lock-outline" aria-hidden="true"></i>
                                                                    </span>
                                                                    <input className="input100 border-start-0 form-control ms-0"  autoComplete={false} defaultValue={""} type={!showPass ? "password" : "text"} ref={confirmation_password} placeholder={t("confirmation new password")} />
                                                                </div>
                                                                <Box sx={{ display: 'flex', justifyContent: "center" }}>
                                                                    <Button sx={{ mt: 3 }} onClick={_setNewPassword}>
                                                                        {activeStep === steps.length - 1 ? t('Finish')  : t('Next')}
                                                                    </Button>
                                                                </Box>
                                                                
                                                            </div>
                                                        </Box>
                                                    )}
                                                    </React.Fragment>
                                                )}
                                            </Box>
                                            

                                            <div className="text-center pt-3">
                                                    <p className="text-dark mb-0">{t('Already have account?')}<Link className="text-primary ms-1" to="/login">{t('Sign In')}</Link></p>
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                    {/* <!-- CONTAINER CLOSED --> */}
                </div>
                <LangSwitcher />
            </div>
            {/* <!-- End PAGE --> */}

        </div>
    );
}

export default ResetPassword;